function Experience() {
    return (
        <p>
            <li>
                Winnie: Increasing accessibility of early childhood education by developing a robust marketplace to connect families looking for care with local providers. Work on search algorithm, 3rd party interations, and internal business logic as a fullstack developer at a start up.
            </li>
            <li>
                <a target='_blank' href='https://www.westmont.edu/westmont-students-design-college-software'>Salesforce</a>: Spearheaded development for a pilot program to migrate college infrastructure using Education Data Architecture (EDA), Lightning Web Components (LWC), and Apex triggers.
            </li>
            <li>
                <a target='_blank' href='https://www.linkedin.com/posts/mission-bit_volunteerappreciationweek-missionbit-empoweringfutureleaders-activity-7188566299453583360-1jnd'>Mission Bit</a>: Assistant for high school Python and Web Design courses, debugging with and mentoring students. I provide constructive feedback on student projects and help with local events.
            </li>
            <li>
                Skills + Technologies: Python, Django, Ruby on Rails, PSQL, Typescript, Docker, Redshift, RDS, Cloudwatch, OpenSearch, React, Sentry, Sendgrid, Segment, Amplitude
            </li>
        </p>
    )
}
export default Experience;